module.exports = __webpack_public_path__ + "9bc77c3bca968c7490de95d1532d0e87.ttf";